import { computed } from 'mobx';

export default class RawDataModel {
  id;
  store;

  constructor(store, rawData) {
    this.store = store;
    this.id = +rawData.id;
    this.request_id = rawData.request_id;
    this.origin_code = rawData.origin_code;
    this.parameter_code = rawData.parameter_code;
    this.time = rawData.time;
    this.value = rawData.value;
    this.flag = rawData.flag;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      request_id: this.request_id,
      origin_code: this.origin_code,
      parameter_code: this.parameter_code,
      time: this.time,
      value: this.value,
      flag: this.flag,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.request_id = json.request_id;
    this.origin_code = json.origin_code;
    this.parameter_code = json.parameter_code;
    this.time = json.time;
    this.value = json.value;
    this.flag = json.flag;
  }
}



// WEBPACK FOOTER //
// ./src/models/RawDataModel.js